import { cn } from '@studio/ui';

export interface LogoMarkProps {
  size?: number;
  className?: string;
}

/**
 * The brand mark — a serif "A" in a rounded square. Color comes from
 * `currentColor` so the mark adapts to its parent (use with `text-primary`
 * for the brand electric blue, `text-fg` for monochrome).
 */
export function LogoMark({ size = 32, className }: LogoMarkProps) {
  return (
    <svg
      role="img"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="AI Product Studio"
      className={className}
    >
      <title>AI Product Studio</title>
      <rect width={32} height={32} rx={8} fill="currentColor" />
      <g fill="#FFFFFF" fillRule="evenodd">
        <path d="M 15.2 6 L 16.8 6 L 24.5 26 L 21.5 26 L 19.6 20.6 L 12.4 20.6 L 10.5 26 L 7.5 26 Z M 13.4 17.8 L 18.6 17.8 L 16 10.4 Z" />
        <rect x={5.8} y={25.3} width={6.4} height={1.2} rx={0.4} />
        <rect x={19.8} y={25.3} width={6.4} height={1.2} rx={0.4} />
      </g>
    </svg>
  );
}

export interface LogoProps {
  size?: number;
  className?: string;
  /** Hide the wordmark and show only the mark. */
  markOnly?: boolean;
}

/**
 * Brand lockup — mark + wordmark. Used in the top-left of the app shell
 * and on auth screens. Wordmark is set in the display serif (Source Serif 4).
 */
export function Logo({ size = 32, className, markOnly = false }: LogoProps) {
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark size={size} className="text-primary" />
      {!markOnly && <span className="wordmark">AI Product Studio</span>}
    </div>
  );
}
